<div class="dialog-content-wrapper">
    <mat-toolbar matDialogTitle class="mat-accent m-0">
        <mat-toolbar-row fxLayout="row" fxLayoutAlign="space-between center">
            <span class="title dialog-title">
                {{ 'Confirm deletion'|translate }}
            </span>
        </mat-toolbar-row>
    </mat-toolbar>

    <div mat-dialog-content class="p-24 pb-0 m-0" fusePerfectScrollbar>
        {{'Are you sure you want to delete selected item?'|translate}}
    </div>
    <form [formGroup]="form" fxLayout="column" fxLayoutAlign="start"
          fxFlex="1 0 auto">
        <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto" class="p-24">
            <mat-form-field appearance="outline" fxFlex="100">
                <mat-label>{{'Deletion reason'|translate}}</mat-label>
                <textarea matInput formControlName="reason" required></textarea>
                <mat-error>{{'Deletion reason is required!'|translate}}</mat-error>
            </mat-form-field>
        </div>
    </form>

    <div mat-dialog-actions class="m-0 p-16" fxLayout="row" fxLayoutAlign="end center">

        <button
                mat-button
                class="mr-8"
                (click)="matDialogRef.close()"
                aria-label="Cancel">
            {{'Cancel'|translate}}
        </button>
        <button
                mat-button
                class="mr-8"
                (click)="matDialogRef.close(form)"
                aria-label="Confirm">
            {{'Confirm'|translate}}
        </button>

    </div>
</div>
